export default "__VITE_ASSET__c4843d94__"